import type { Player, TeamState, TeamTactics } from '../useGameStore';

export const EMPTY_TEAM: TeamState = {
  roster: [],
  court: [],
  courtRoles: [],
  bench: [],
  libero: null,
  playerRoles: {},
};

export const DEFAULT_ROSTER: Player[] = [
  { id: '1', name: 'Mathieu', role: 'R4' },
  { id: '2', name: 'Ethan', role: 'R4' },
  { id: '3', name: 'Liam', role: 'R4' },
  { id: '4', name: 'Adam', role: 'R4' },
  { id: '5', name: 'Sloan', role: 'Pointu' },
  { id: '6', name: 'Ugo', role: 'Central' },
  { id: '7', name: 'Edouard', role: 'Central' },
  { id: '8', name: 'Antoine', role: 'Central' },
  { id: '9', name: 'Lucas', role: 'Passeur' },
  { id: '10', name: 'Aurelien', role: 'Passeur' },
  { id: '11', name: 'Enzo', role: 'Lib' },
  { id: '12', name: 'Arthur', role: 'Pointu' },
  { id: '13', name: 'Alexis', role: 'Lib' },
];

export const DEFAULT_TEAM_TACTICS: TeamTactics = {
  p1AttackZone2: 'R4',
  liberoDefenseZone: 5,
  centralDefenseZone: 6,
};
